import React from 'react';
import { Link } from 'react-router-dom';
import BlogSection from '../components/sections/BlogSection';
import './PageLayout.css';

const BlogsPage = () => {
  return (
    <div className="page-layout">
      <Link to="/" className="back-button">← Home</Link>
      <div className="page-content">
        <BlogSection />
      </div>
    </div>
  );
};

export default BlogsPage;

